import DataLoading from "./DataLoading"

class Parameter {
  constructor(jsonParam) {
    for(let key in jsonParam) {
      if(key !== "description") this[key] = jsonParam[key]
    }
  }
}

class ParametersPool {
  params = {}

  init() {
    this.params = {}
    let json = DataLoading.parameters
    json.forEach(jsonParam => {
      this.params[jsonParam.id] = new Parameter(jsonParam)
    })
  }


  applyScenario(scenario) {
    scenario.parameters.forEach(v => {
      const p = this.get(v.id)
      if(v.min !== null) p.min = v.min
      if(v.def !== null) p.def = v.def
      if(v.max !== null) p.max = v.max
    })
  }

  getDef(id) {
    let param = this.get(id)
    if(param === undefined) return undefined
    return param.def
  }
  getMin(id) {
    let param = this.get(id)
    if(param === undefined) return undefined
    return param.min
  }
  getMax(id) {
    let param = this.get(id)
    if(param === undefined) return undefined
    return param.max
  }

  get(id) {
    if(!id) return undefined

    let param = this.params[id]

    if(param === undefined) {
      console.error("ERROR NO PARAM", id)
    }
    return param
  }

}


export default new ParametersPool()
